var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.oldTokenExist)?_c('a',{staticClass:"float",on:{"click":_vm.backToAdmin}},[_c('i',{staticClass:"fas fa-backward my-float"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }